import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { advertisement, ServiceService } from '../service.service';
import { ModalController, IonInfiniteScroll } from '@ionic/angular';
import { ThreadModalPage } from '../thread-modal/thread-modal.page';
import { ModalImagesPage } from '../modalImages/modalImages.page';
import { LoadingController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import {Location} from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { PostsModalPage } from '../posts-modal/posts-modal.page';

@Component({
  selector: 'app-threads',
  templateUrl: './threads.page.html',
  styleUrls: ['./threads.page.scss', '../../assets/scss/styles.scss'],
})
export class ThreadsPage implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  idPost: string;
  idUser;
  detail: string;
  listThreads: any;
  listThreadsTemp: any;
  DEFAULT_PAGE = 1;
  detailString: string;
  username: string;
  imageUrl: string;
  ids;
  
  iduser;
  roleId: number;
  isMovil:boolean = false;
  advertisements:advertisement = new advertisement();
  @ViewChild('contentCenter') contentCenter: ElementRef;

  constructor(
    private activatedRoute: ActivatedRoute,
    public services: ServiceService,
    public modalController: ModalController,
    private loadingController: LoadingController,
    private alertCtrl: AlertController,
    private router: Router,
    public sanitizer: DomSanitizer
  ) {
    this.iduser = JSON.parse(localStorage.getItem('idUser'));
    this.roleId = JSON.parse(localStorage.getItem('roleId'));
  }

  async ngOnInit() {
    this.loadThreads();
    this.isMovil = this.services.isMovil();
    if(!this.isMovil){
      this.advertisements = await this.services.getAdvertisementByScreen(5);
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,this.advertisements.Rows);
      this.advertisements.Random = this.services.NumberRandom(this.advertisements.Principal.length);
      this.services.postAdvertisementUser(this.advertisements.getAllRelAdsMetricsIdDisplayed());
    }
  }

  async scrollingAds(event:any) {
    let rows = Math.floor(Number(event.detail.scrollTop-this.advertisements.SizePage)/this.advertisements.SizeDivImage);
    let final = rows+this.advertisements.Rows;
    if(event.detail.scrollTop > this.advertisements.SizePage && rows>0 && final > this.advertisements.Displayed.length && this.advertisements.Displayed.length < this.advertisements.MediaBasico.length && event.detail.scrollTop < (this.contentCenter.nativeElement.clientHeight-this.advertisements.SizePage)){
      let displayedLength = this.advertisements.Displayed.length;
      this.advertisements.Displayed = this.advertisements.MediaBasico.slice(0,final);
      let disply = this.advertisements.Displayed.slice(displayedLength,this.advertisements.Displayed.length);
      this.services.postAdvertisementUser(this.advertisements.getRelAdsMetricsId(disply));
    }
  }

  backClicked() {
    const id = JSON.parse(localStorage.getItem('idposts'));
    const url = localStorage.getItem('urls');
    this.services.goBack();
    /* if ( url === '/comunidad-cnc') {
      this.router.navigate(['/comunidad-cnc']);
    } else {
      this.router.navigateByUrl(`/posts/${id}`);
    } */
  }

  async loadThreads(event = null) {
    this.DEFAULT_PAGE=1;
    this.idPost = await this.activatedRoute.snapshot.paramMap.get('id');
    this.idUser = await this.activatedRoute.snapshot.paramMap.get('userid');
    this.detail = await this.activatedRoute.snapshot.paramMap.get('detail');
    await this.servicioBaseRefresh(event);
  }
  async loadThreadsScroll(event) {
    this.idPost = await this.activatedRoute.snapshot.paramMap.get('id');
    this.idUser = await this.activatedRoute.snapshot.paramMap.get('userid');
    this.detail = await this.activatedRoute.snapshot.paramMap.get('detail');
    await this.servicioBase(event);
  }

  async openModal() {
    //  console.log("async openModal()");

    const modal = await this.modalController.create({
      component: ThreadModalPage,
      cssClass:(!this.services.isMovil())?'custom-modal':'',
      componentProps: { 
        postId : this.idPost,
        notification1 : "notification1",
        detail: this.detail,
        userId: this.idUser
      }
    });
    modal.onDidDismiss().then(async data => {
      await this.loadThreads();
    });
    return await modal.present();
  }

  async openModalImages(images,current) {
    //  console.log("async openModalImages(images,current)");

    const modal = await this.modalController.create({
      component: ModalImagesPage,
      cssClass: 'my-custom-class',
      componentProps: {
        'images': images,
        'current': current

      }
    });
    return await modal.present();
  }

  getElapsedTime(date){
    //  console.log("getElapsedTime(date)");

    return this.services.getElapsedTime(date);
  }

  async presentAlert(mensaje) {
    //  console.log("async presentAlert(mensaje)");

   /*  const alert = await this.alertCtrl.create({
      header: 'Like!',
      message: mensaje,
      buttons: ['OK'],
    });

    await alert.present();
    let result = await alert.onDidDismiss(); */
  }

  async likeThreadUser(threadId,index){
    //  console.log("async likeThreadUser(threadId,index)");

    this.listThreads[index].likesThreadUsersCount++;
    this.listThreads[index].likesThreadUser = true;

    this.services.postLikeThreadsUser(threadId).subscribe((data) => {
      const thread = data;

      this.listThreads[index].likesThreadUsers = thread[0].likesThreadUsers;
      this.listThreads[index].likesThreadUsersCount = thread[0].likesThreadUsersCount;
      this.listThreads[index].likesThreadUser = true;
    }, (error) => {
      console.log('Error servicio postLikeThreadsUser:', error);

      if (this.listThreads[index].likesThreadUsersCount > 0) {
        this.listThreads[index].likesThreadUsersCount--;
        this.listThreads[index].likesThreadUser = false;
      }
    });
  }

  async likeThreadUserDelete(threadId,index){
    //  console.lo("async likeThreadUserDelete(threadId,index)");

    if (this.listThreads[index].likesThreadUsersCount > 0) {
      this.listThreads[index].likesThreadUsersCount--;
      this.listThreads[index].likesThreadUser = false;
    }

    this.services.postLikeThreadUserDelete(threadId).subscribe(async (data) => {
      const thread = data;
      this.listThreads[index].likesThreadUsers = thread[0].likesThreadUsers;
      this.listThreads[index].likesThreadUsersCount = thread[0].likesThreadUsersCount;
      this.listThreads[index].likesThreadUser = false;
    }, (error) => {
      console.log(error);
      this.listThreads[index].likesThreadUsersCount++;
      this.listThreads[index].likesThreadUser = true;
    });
  }

  async servicioBase(event){
    const loading = await this.loadingController.create({
      message: 'Cargando respuestas…', duration: 1000
    });
    await loading.present();
    this.services.getThreadsByPost(this.idPost,this.DEFAULT_PAGE).subscribe(
      async (data) => {
        this.listThreadsTemp = data;
        if(this.listThreadsTemp === undefined){
          this.listThreads = await data;
          this.listThreads =[];
        }else
        if(this.DEFAULT_PAGE==1){
          this.listThreads =await data;
          this.listThreads =[];
        }
        this.listThreads = [...this.listThreads,...this.listThreadsTemp]
        if(event!=null){
          await event.target.complete();
          if (this.listThreadsTemp.length < 10) {
            event.target.disabled = true;
          }
        }
        this.DEFAULT_PAGE++;
        await loading.dismiss();
      },
      (error) => {
        console.log(error);
      }
    );
  }
  async servicioBaseRefresh(event){
    const loading = await this.loadingController.create({
      message: 'Cargando respuestas…', duration: 1000
    });
    await loading.present();
    this.services.getThreadsByPost(this.idPost,this.DEFAULT_PAGE).subscribe(
      async (data) => {
        this.listThreadsTemp = data;
        if(this.listThreadsTemp === undefined){
          this.listThreads = await data;
          this.listThreadsTemp =[];
        }else
        if(this.DEFAULT_PAGE==1){
          this.listThreads =await data;
          this.listThreadsTemp =[];
        }
        this.listThreads = [...this.listThreads,...this.listThreadsTemp]
        if(event!=null){
          await event.target.complete();
          
        }
        await this.toggleInfiniteScroll();
        this.DEFAULT_PAGE++;
        await loading.dismiss();
      },
      (error) => {
        console.log(error);
      }
    );
  }
  async toggleInfiniteScroll() {
    this.infiniteScroll.disabled = await false;
  }
  //Envió de notificación al usuario al hacer un like
  async postNotificationLike(notification1, thread, userid){
    this.detailString = thread;
    this.imageUrl = localStorage.getItem("imageUrl");
    if(this.detailString.length > 25){
      this.detailString = localStorage.getItem("completeName") + ' le dió like a "' + this.detailString.substr(0, 25) + '..."';
    }
    else{
      this.detailString = localStorage.getItem("completeName") + ' le dió like a "' + this.detailString  + '"';
    }
    (await this.services.postNotifications(notification1, this.detailString, userid, this.imageUrl)).subscribe(
      async (data) => {
      },
      (error) => {
        console.log(error);
      }
    );

  }
  async deleteThread(threadId, index) {
    const alert = await this.alertCtrl.create({
      message: '¿Seguro de eliminar este comentario?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {
          }
        }, {
          text: 'Aceptar',
          handler: () => {
            this.services.deleteThread(threadId).subscribe( () => {
              this.listThreads.splice(index, 1);
            }, error => console.error(error));
          }
        }
      ]
    });
    await alert.present();
  }

}


